module.exports = __webpack_public_path__ + "static/media/flag-sd.9e30612e.webp";